import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import { z } from 'zod';
import { privateHttpClient } from '../httpClient';
import { createApiResponseSchema } from '../utils';
import { profileApiPath } from './apiPath';

// Request schema
const GetCuratorNicknameCheckDuplicateRequestSchema = z
  .object({
    nickname: z.string(),
  })
  .describe('GetCuratorNicknameCheckDuplicateRequestSchema');

// Response data schema
const GetCuratorNicknameCheckDuplicateResponseDataSchema = z
  .object({
    available: z.boolean(),
  })
  .describe('GetCuratorNicknameCheckDuplicateResponseDataSchema');

const GetCuratorNicknameCheckDuplicateResponseSchema = createApiResponseSchema(
  GetCuratorNicknameCheckDuplicateResponseDataSchema,
);

type GetCuratorNicknameCheckDuplicateRequest = z.infer<
  typeof GetCuratorNicknameCheckDuplicateRequestSchema
>;
type GetCuratorNicknameCheckDuplicateResponse = z.infer<
  typeof GetCuratorNicknameCheckDuplicateResponseSchema
>;

export const getCuratorNicknameCheckDuplicate = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(GetCuratorNicknameCheckDuplicateRequestSchema),
    (params: GetCuratorNicknameCheckDuplicateRequest) =>
      executeStandardRequest(async () =>
        privateHttpClient.get<GetCuratorNicknameCheckDuplicateResponse>(
          `${profileApiPath.getCuratorNicknameCheckDuplicate}?nickname=${encodeURIComponent(
            params.nickname,
          )}`,
        ),
      ),
    validateApiResponse(GetCuratorNicknameCheckDuplicateResponseSchema),
  ),
);
